export enum ChatAgentToolName {
  SearchByKeyword = 'search_by_keyword_tool',
  QueryDb = 'query_db_tool',
  ReadCustomer = 'read_customer_tool',
  ReadDocument = 'read_document_tool',
  Calculate = 'calculate_tool',
  SearchKnowledgebase = 'search_knowledgebase_tool',
  AnalyseTransactions = 'analyse_transactions_tool',
  CheckSummarySection = 'check_summary_section_tool',
  CompareNames = 'compare_names_tool',
}

export enum ChatAgentResponseChunkType {
  AssistantResponseStart = 'ASSISTANT_RESPONSE_START',
  AssistantResponseDelta = 'ASSISTANT_RESPONSE_DELTA',
  ToolCall = 'TOOL_CALL',
  ToolResult = 'TOOL_RESULT',
  Error = 'ERROR',
}

export interface AssistantResponseStartChunk {
  type: ChatAgentResponseChunkType.AssistantResponseStart;
  content: string;
}

export interface AssistantResponseDeltaChunk {
  type: ChatAgentResponseChunkType.AssistantResponseDelta;
  content_delta: string;
}

export interface ToolCallChunk {
  type: ChatAgentResponseChunkType.ToolCall;
  tool_call_id: string;
  tool_name: ChatAgentToolName;
  args: string | Record<string, unknown>;
}

export interface ToolResultChunk {
  type: ChatAgentResponseChunkType.ToolResult;
  tool_call_id: string;
  tool_name?: ChatAgentToolName;
  result: string | Record<string, unknown>;
}

export interface ErrorChunk {
  type: ChatAgentResponseChunkType.Error;
  error: string;
}

export type ChatAgentResponseChunk =
  | AssistantResponseStartChunk
  | AssistantResponseDeltaChunk
  | ToolCallChunk
  | ToolResultChunk
  | ErrorChunk;

export enum UiMessageType {
  UserMessage = 'USER_MESSAGE',
  AssistantMessage = 'ASSISTANT_MESSAGE',
  ToolMessage = 'TOOL_MESSAGE',
  Error = 'ERROR',
}

export interface UiUserMessage {
  type: UiMessageType.UserMessage;
  content: string;
}
export interface UiAssistantMessage {
  type: UiMessageType.AssistantMessage;
  content: string;
}

export interface UiToolMessage {
  type: UiMessageType.ToolMessage;
  toolCallId: string;
  toolName: ChatAgentToolName;
  args: string | Record<string, unknown>;
  result?: string | Record<string, unknown>;
}
export interface UiErrorMessage {
  type: UiMessageType.Error;
  content: string;
}

export type UiMessage =
  | UiUserMessage
  | UiAssistantMessage
  | UiToolMessage
  | UiErrorMessage;

export enum ChatContextType {
  Customer = 'CUSTOMER',
  Document = 'DOCUMENT',
  Global = 'GLOBAL',
}

export interface ChatContextCustomer {
  type: ChatContextType.Customer;
  customerUuid: string;
  customerName: string;
}

export interface ChatContextDocument {
  type: ChatContextType.Document;
  documentId: string;
  customerUuid: string;
  documentName: string;
}

export interface ChatContextGlobal {
  type: ChatContextType.Global;
}

export type ChatContext =
  | ChatContextCustomer
  | ChatContextDocument
  | ChatContextGlobal;
